/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Tables from "layouts/tables";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import ResetPassword from "layouts/authentication/reset-password/cover";
import Devices from "layouts/devices";
import CleaningHistory from "layouts/cleaningHistory";
import CorrectionHistory from "layouts/correctionHistory";
import CalibrationHistory from "layouts/calibrationHistory";
import RateTable from "layouts/rateTable";
import SomaticCells from "layouts/somaticCells";
import TestInfoLayout from "layouts/testInfo";

// @mui icons
import Icon from "@mui/material/Icon";
import PrivateRoute from "components/PrivateRoute";
import HistoryRoute from "components/HistoryRoute";
import SomaticRoute from "components/SomaticRoute";

const routes = [
  {
    menu: true,
    type: "collapse",
    name: "Tables",
    key: "tables",
    icon: <Icon fontSize="small">table_view</Icon>,
    route: "/tables",
    component: <PrivateRoute Component={Tables} />,
  },
  {
    menu: true,
    type: "collapse",
    name: "Devices",
    key: "devices",
    icon: <Icon fontSize="small">devices</Icon>,
    route: "/devices",
    component: <PrivateRoute Component={Devices} />,
  },
  {
    menu: true,
    requiresHistory: true,
    type: "collapse",
    name: "Cleaning History",
    key: "cleaning-history",
    icon: <Icon fontSize="small">cleaning_services</Icon>,
    route: "/cleaning-history",
    component: <HistoryRoute Component={CleaningHistory} />,
  },
  {
    menu: true,
    requiresHistory: true,
    type: "collapse",
    name: "Correction History",
    key: "correction-history",
    icon: <Icon fontSize="small">history</Icon>,
    route: "/correction-history",
    component: <HistoryRoute Component={CorrectionHistory} />,
  },
  {
    menu: true,
    requiresHistory: true,
    type: "collapse",
    name: "Calibration History",
    key: "calibration-history",
    icon: <Icon fontSize="small">science</Icon>,
    route: "/calibration-history",
    component: <HistoryRoute Component={CalibrationHistory} />,
  },
  {
    menu: true,
    type: "collapse",
    name: "Test Report",
    key: "test-report",
    icon: <Icon fontSize="small">report</Icon>,
    route: "/test-report",
    component: <PrivateRoute Component={TestInfoLayout} />,
  },
  {
    menu: true,
    type: "collapse",
    name: "Rate Table",
    key: "rate-table",
    icon: <Icon fontSize="small">assessment</Icon>,
    route: "/rate-table",
    component: <PrivateRoute Component={RateTable} />,
  },
  {
    menu: true,
    requiresSomatics: true,
    type: "collapse",
    name: "Somatic Cells",
    key: "somatic-cells",
    icon: <Icon fontSize="small">biotech</Icon>,
    route: "/somatic-cells",
    component: <SomaticRoute Component={SomaticCells} />,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/authentication/sign-in",
    component: <SignIn />,
  },
  {
    type: "collapse",
    name: "Sign Up",
    key: "sign-up",
    icon: <Icon fontSize="small">assignment</Icon>,
    route: "/authentication/sign-up",
    component: <SignUp />,
  },
  {
    type: "collapse",
    name: "Reset Password",
    key: "reset-password",
    icon: <Icon fontSize="small">lock_reset</Icon>,
    route: "/authentication/reset-password",
    component: <ResetPassword />,
  },
];

export default routes;
